module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"fieldLabelLatitude":"Latitude","fieldLabelLongitude":"Longitude","fieldLabelZoom":"Niveau de zoom"},"en":{"fieldLabelLatitude":"Latitude","fieldLabelLongitude":"Longitude","fieldLabelZoom":"Zoom level"}}')
  delete Component.options._Ctor
}
